import { useState } from "react";
import CustomDialogSmall from "../../../components/Dialog/DiaCompSmall";
import { Tooltip, IconButton, Grid, Typography, Box, Paper, Divider, Stack} from '@mui/material';
import { MapPin, Phone, Mail, FileText, CheckCircle, Info } from 'lucide-react';
import { useTranslation } from "../../../language";

export default function DiaLabDetails({labDetails}) {

    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
  
        <Tooltip title={t("onb_lab_contact_tooltip")} placement="top">
            <IconButton onClick={handleOpen} aria-label="Reschedule" sx={{ '&:hover': {transform: 'scale(1.2)'}, }} >
                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Info size={22} sx={{color: 'warning.main', '&:hover': { transform: 'scale(1.3)'},  }} />
                  </Box>
            </IconButton>   
        </Tooltip>
   
    <CustomDialogSmall open={open} onClose={handleClose}

          title={t("onb_lab_contact_title")}
         
          content = {<>
         
               
               {/* 🔹 Show selected lab details */}
               <Grid container spacing={2} sx={{ mt: 2, justifyContent: 'center' }}>
                 <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                   <Box sx={{ maxWidth: 700, width: '100%' }}>
                     {labDetails && (
                       <Paper
                         elevation={0}
                         sx={{
                            borderRadius: 3,
                            p: 4,
                            bgcolor: 'transparent'
                         }}
                       >
                         <Stack spacing={2.5}>
                           {/* Address */}
                           <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                             <MapPin size={22} color="#1976d2" style={{ marginTop: 2, flexShrink: 0 }} />
                             <Box>
                               <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5, fontWeight:400 }}>
                                 {t("onb_lab_info_address")}
                               </Typography>
                               <Typography variant="subtitle1" sx={{fontWeight:400}}>
                                 {[
                                   labDetails.details?.address?.street,
                                   labDetails.details?.address?.city,
                                   labDetails.details?.address?.postal_code,
                                   labDetails.details?.address?.country
                                 ].filter(Boolean).join(', ')}
                               </Typography>
                             </Box>
                           </Box>
               
                           <Divider />
               
                           {/* Phone */}
                           {labDetails.details?.phone && (
                             <>
                               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                 <Phone size={22} color="#1976d2" style={{ flexShrink: 0 }} />
                                 <Box>
                                   <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5, fontWeight:400 }}>
                                     {t("onb_lab_info_phone")}
                                   </Typography>
                                   <Typography variant="subtitle1" sx={{fontWeight:400}}>
                                     {labDetails.details.phone}
                                   </Typography>
                                 </Box>
                               </Box>
                               <Divider />
                             </>
                           )}
               
                           {/* Email */}
                           {labDetails.details?.email && (
                             <>
                               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                 <Mail size={22} color="#1976d2" style={{ flexShrink: 0 }} />
                                 <Box>
                                   <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5, fontWeight:400 }}>
                                     {t("onb_lab_info_email")}
                                   </Typography>
                                   <Typography variant="subtitle1" sx={{fontWeight:400}}>
                                     {labDetails.details.email}
                                   </Typography>
                                 </Box>
                               </Box>
                               <Divider />
                             </>
                           )}
               
                           {/* Notes */}
                           {labDetails.details?.notes && (
                             <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                               <FileText size={22} color="#1976d2" style={{ marginTop: 2, flexShrink: 0 }} />
                               <Box>
                                 <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5, fontWeight:400 }}>
                                   {t("onb_lab_info_notes")}
                                 </Typography>
                                 <Typography variant="subtitle1" sx={{fontWeight:400}}>
                                   {labDetails.details.notes}
                                 </Typography>
                               </Box>
                             </Box>
                           )}
                         </Stack>
                       </Paper>
                     )}
                   </Box>
                 </Grid>
               </Grid>
            </>
            }

        />
        
</>
)}